import React, { useEffect, useRef, useState } from "react";
import Attachments from "../../../../components/Attachments/Attachments";
import Notifications from "../../../../components/Notifications/Notifications";
import { IoMdNotificationsOutline } from "react-icons/io";
import { useStateValue } from "../../../../StateProvider";
import { useForm } from "react-hook-form";
import {
  addProjectTemp,
  getProjectTemplateDetail,
  updateProjectTemp,
} from "../../../../apiCall";
import toast from "react-hot-toast";
import { DateToYYYYMMDD } from "../../../../utils/FormateDate";
import TaskTempList from "./Components/TaskTempList";
import { useNavigate, useParams } from "react-router-dom";
import { ExtractDays } from "../../../../utils/ExtractDays";
import { FaLeaf } from "react-icons/fa";
import EncodeAprxDuration from "../../../../utils/EncodeAprxDuration";
import DecodeAprxDuration from "../../../../utils/DecodeAprxDuration";
import { useQuery } from "@tanstack/react-query";
import Attachment from "../../../Attachment/Attachment";
import { validateNoBlankSpaces } from "../../../../utils/formValidation";

const AddUpdateProjectTemp = () => {
  const [tab, setTab] = useState("information");
  const [, dispatch] = useStateValue();
  const { projectId } = useParams();
  const navigate = useNavigate();
  const [isSaveAndAddTaskTemp, setIsSaveAndAddTaskTemp] = useState(false);
  const [projectName, setProjectName] = useState("");
  const [isSaveAndEditTask, setIsSaveAndEditTask] = useState(false);
  const [editTaskId, setEditTaskId] = useState();
  const [projectData, setProjectData] = useState({});

  //******************************************attachment start **************************************************
  const [attachmentCount, setAttachmentCount] = useState(0);
  const [isAddAttachments, setIsAddAttachments] = useState(false);
  const [title, setTitle] = useState("Add Project Template Form");
  const formRef = useRef(null);
  const updateUrl = (newPath) => {
    const currentUrl = new URL(window.location.href);
    const searchParams = new URLSearchParams(currentUrl.search);

    // Construct new URL
    // const newPath = '/update/task/31';
    const newUrl = `${newPath}?${searchParams.toString()}`;

    // Navigate to the new URL
    navigate(newUrl);
  };

  const handleExternalSubmit = () => {
    if (tab === "information") {
      setIsAddAttachments(true);
      if (formRef.current) {
        setTimeout(() => {
          formRef.current.dispatchEvent(
            new Event("submit", { cancelable: true, bubbles: true })
          );
        }, 100);
      }
    } else {
      setTab("attachments");
      setTitle(
        projectId ? "Update Project Template Form" : "Add Project Template Form"
      );
    }
  };
  useEffect(() => {
    if (projectId && tab === "information") {
      setTitle("Update Project Template Form");
    }
    if (!projectId && tab === "information") {
      setTitle("Add Project Template Form");
    }
  }, [projectId]);

  //******************************************attachment end **************************************************

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      AprxDays: 0,
      AprxHours: 0,
      AprxMinutes: 0,
    },
  });
  const onSubmit = async (data) => {
    if (false) {
      // if (data?.AprxDays === 0 && data?.AprxHours === 0) {
      toast.error("Days and hours cannot both be 0.");
    } else {
      dispatch({ type: "SET_LOADING", status: true });
      // const totalDays = EncodeAprxDuration(
      //   data?.AprxDays===""? 0:data?.AprxDays,
      //   data?.AprxHours===""? 0:data?.AprxHours,
      //   data?.AprxMinutes===""? 0:data?.AprxMinutes
      // );
      // data.AprxDuration = totalDays;
      delete data.AprxDays;
      delete data.AprxHours;
      delete data.AprxMinutes;
      console.log(projectId);
      if (projectId) {
        if (
          projectData?.Name === data?.Name &&
          projectData?.Dscr === data?.Dscr
        ) {
          if (isSaveAndEditTask) {
            setIsSaveAndEditTask(false);
            navigate(`/update/task-template/${editTaskId}`);
          }
          else if (isAddAttachments) {
            setTab("attachments");
            setTitle(
              projectId
                ? "Update Project Template Form"
                : "Add Project Template Form"
            );
            setIsAddAttachments(false);
          }
          else {
            if (isSaveAndAddTaskTemp) {
              setIsSaveAndAddTaskTemp(false);

              navigate(`/add/task-template/${projectId}/${projectName}`);
            } else {
              navigate(`/project-template?projectId=${projectId}`);
              reset();
            }
          }
        } else {
          const re = await updateProjectTemp(projectId, data);
          if (re?.status === 200) {
            // setActiveTab("projectTempList");
            if (isSaveAndEditTask) {
              setIsSaveAndEditTask(false);
              navigate(`/update/task-template/${editTaskId}`);
            } else {
              if (isSaveAndAddTaskTemp) {
                setIsSaveAndAddTaskTemp(false);

                navigate(`/add/task-template/${projectId}/${projectName}`);
              }
              else if (isAddAttachments) {
                setTab("attachments");
                setTitle(
                  projectId
                    ? "Update Project Template Form"
                    : "Add Project Template Form"
                );
                setIsAddAttachments(false);
              }
              else {
                navigate(`/project-template?projectId=${projectId}`);
                reset();
              }
              toast.success(re?.data?.message);
            }

            console.log(re.data);
          } else if(re?.response)  {
            toast.error(re?.response?.data?.message);
          }
        }
      } else {
        const re = await addProjectTemp(data);
        console.log(re);
        if (re?.status === 201) {
          // setActiveTab("projectTempList");
          reset();
          if (isSaveAndAddTaskTemp) {
            setIsSaveAndAddTaskTemp(false);
            navigate(`/add/task-template/${re.data.data.ID}/${data?.Name}`);
          }
          else if (isAddAttachments) {
            setTab("attachments");
            updateUrl(`/update/project-template/${re?.data?.data?.ID}`);
            setTitle(
              projectId
                ? "Update Project Template Form"
                : "Add Project Template Form"
            );

            setIsAddAttachments(false);
          }
          else {
            navigate(`/project-template?projectId=${re.data.data.ID}`);
          }
          console.log(re.data);
          toast.success(re?.data?.messgae);
        } else if(re?.response) {
          toast.error(re?.response?.data?.message);
        }
      }

      dispatch({ type: "SET_LOADING", status: false });
    }
  };
  const fetchData = async () => {
    dispatch({ type: "SET_LOADING", status: true });
    const re = await getProjectTemplateDetail(projectId);
    if (re?.status === 200) {
      console.log(re.data);
      // setValue("TaskTmplID", re.data?.TaskTmplID);
      setProjectData({
        // "OrdNo": re.data?.OrdNo,
        Name: re.data?.Name,
        Dscr: re.data?.Dscr,
        // "AprxDuration": re.data?.AprxDuration,
      });
      // setValue("OrdNo", re.data?.OrdNo);
      setValue("Name", re.data?.Name);
      setProjectName(re.data?.Name);
      setValue("Dscr", re.data?.Dscr);
      setAttachmentCount(re.data?.attachments_no);
      if (re?.data?.AprxDuration != "None") {
        const [days, hours, minutes] = DecodeAprxDuration(
          re?.data?.AprxDuration
        );
        setValue("AprxDays", days);
        setValue("AprxHours", hours);
        setValue("AprxMinutes", minutes);
      }
    } else if(re?.response)  {
      toast.error(re?.response?.data?.message);
    }
    dispatch({ type: "SET_LOADING", status: false });
  };

  // useEffect(() => {
  //   const fetchData = async () => {
  //     dispatch({ type: "SET_LOADING", status: true });
  //     const re = await getProjectTemplateDetail(projectId);
  //     if (re?.status === 200) {
  //       console.log(re.data);
  //       // setValue("TaskTmplID", re.data?.TaskTmplID);
  //       setValue("OrdNo", re.data?.OrdNo);
  //       setValue("Name", re.data?.Name);
  //       setProjectName(re.data?.Name);
  //       setValue("Dscr", re.data?.Dscr);
  //       if (re?.data?.AprxDuration != "None") {
  //         const [days, hours, minutes] = DecodeAprxDuration(
  //           re?.data?.AprxDuration
  //         );
  //         setValue("AprxDays", days);
  //         setValue("AprxHours", hours);
  //         setValue("AprxMinutes", minutes);
  //       }
  //     } else {
  //       toast.error(re?.response?.data?.message);
  //     }
  //     dispatch({ type: "SET_LOADING", status: false });
  //   };
  //   if (projectId) {
  //     fetchData();
  //   }
  // }, [projectId]);

  const { data: projectTempDetail, refetch } = useQuery({
    queryKey: ["project-temp-detail"],
    queryFn: fetchData,
    enabled: projectId ? true : false,
    onSuccess: (Re) => {
      console.log(Re);
    },
    onError: (e) => {
      console.log(e);
    },
  });

  return (
    <div id="app-content">
      {/* Container fluid */}
      <div className="app-content-area mb-10">
        <div className="container-fluid ">
          <div className="mx-n6 mt-n6 pt-6 mb-6 header">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-12">
                {/* Page header */}
                <div
                  className="d-lg-flex
          align-items-center justify-content-between  px-6"
                >
                  <div className=" mb-lg-0">
                    <div className="d-flex align-items-center">
                      <div className="">
                        <h1 className="mb-0 h3 ">
                          {title}
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  {/* nav  */}
                  <ul className="nav nav-lb-tab px-6">
                    <li className="nav-item ms-0 me-3">
                      <div
                        role="button"
                        // className="nav-link active "
                        className={`${tab === "information"
                            ? "nav-link active "
                            : "nav-link"
                          }`}
                        onClick={() => {
                          setTab("information");
                          setTitle(
                            projectId
                              ? "Update Project Template Form"
                              : "Add Project Template Form"
                          );
                        }}
                      >
                        Information
                      </div>
                    </li>
                    <li className="rounded-circl notification-count nav-item mx-3">
                      <div
                        role="button"
                        className={`${tab === "attachments"
                            ? "nav-link active "
                            : "nav-link"
                          }`}
                        onClick={() => {
                          handleExternalSubmit();
                        }}
                      >
                        Attachments
                      </div>
                      <div
                        className="notification-count d-flex justify-content-center"
                        style={{ top: "3px", right: "-14px" }}
                      >
                        {attachmentCount}
                      </div>
                    </li>
                    {/* <li className="nav-item mx-3">
                      <div
                        role="button"
                        className={`${
                          tab === "notifications"
                            ? "nav-link active "
                            : "nav-link"
                        }`}
                        onClick={() => setTab("notifications")}
                      >
                        Notifications
                      </div>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-12">
              {/* Page header */}
              {/* <div className="mb-5">
                <h3 className="mb-0 ">Add Staff</h3>
              </div> */}
            </div>
          </div>
          <div>
            {/* row */}
            <div className="row">
              <div className="col-xl-12 col-md-12 col-12">
                {/* card */}
                {(() => {
                  switch (tab) {
                    case "information":
                      return (
                        <form onSubmit={handleSubmit(onSubmit)} ref={formRef}>
                          <div className="card ">
                            {/* card body */}
                            <div className="card-body" style={{ padding: "10px" }}>
                              {/* form */}
                              <div className="row">
                                {/* form group */}
                                <div className="mb-4 col-md-12 col-12">
                                  <label className="form-label">
                                    Name <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter name"
                                    {...register("Name", {
                                      required: "Name is required",
                                      validate: validateNoBlankSpaces,
                                    })}
                                  />
                                  {errors.Name && (
                                    <div className="error">
                                      {errors.Name.message}
                                    </div>
                                  )}
                                </div>

                                {/* form group */}
                                <div className="mb-4 col-md-12 col-12">
                                  <label className="form-label">
                                  Description{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <textarea
                                    type="text"
                                    rows={5}
                                    className="form-control"
                                    placeholder="Enter description"
                                    {...register("Dscr", {
                                      required: "Description is required",
                                      validate: validateNoBlankSpaces,
                                    })}
                                  ></textarea>
                                  {errors.Dscr && (
                                    <div className="error">
                                      {errors.Dscr.message}
                                    </div>
                                  )}
                                </div>

                                {/* form group */}
                                <div className="mb-4 col-md-3 col-6">
                                  <label className="form-label">
                                    Approx Days{" "}
                                    {/* <span className="text-danger">*</span> */}
                                  </label>
                                  <input
                                    type="number"
                                    min="0"
                                    className="form-control"
                                    placeholder="Enter Days"
                                    disabled
                                    {...register("AprxDays", {
                                      // required: "Approx Days is required",
                                    })}
                                  />
                                  {errors.AprxDays && (
                                    <div className="error">
                                      {errors.AprxDays.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-3 col-6">
                                  <label className="form-label">
                                    Approx Hours{" "}
                                    {/* <span className="text-danger">*</span> */}
                                  </label>
                                  <input
                                    type="number"
                                    min="0"
                                    disabled
                                    className="form-control"
                                    placeholder="Enter Hours"
                                    {...register("AprxHours", {
                                      max: {
                                        value: 23,
                                        message:
                                          "approx hours must be less than 24",
                                      },
                                      // required: "Approx Hours is required",
                                    })}
                                  />
                                  {errors.AprxHours && (
                                    <div className="error">
                                      {errors.AprxHours.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-3 col-6 ">
                                  <label className="form-label">
                                    Approx Minutes{" "}
                                    {/* <span className="text-danger">*</span> */}
                                  </label>
                                  <input
                                    type="number"
                                    min="0"
                                    disabled
                                    className="form-control"
                                    placeholder="Enter Minutes"
                                    {...register("AprxMinutes", {
                                      max: {
                                        value: 59,
                                        message:
                                          "approx hours must be less than 60",
                                      },
                                      // required: "Approx Minutes is required",
                                    })}
                                  />
                                  {errors.AprxMinutes && (
                                    <div className="error">
                                      {errors.AprxMinutes.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}

                              </div>
                            </div>
                                <div className="col-md-12 col-12">
                                  <label className="form-label" style={{ margin: "0px" }}>

                                    <h3 style={{ margin: "0px", paddingLeft: "20px" }}>
                                      Tasks{" "}
                                      <span className="text-danger">*</span>
                                    </h3>
                                  </label>
                                  <TaskTempList
                                    setIsSaveAndAddTaskTemp={
                                      setIsSaveAndAddTaskTemp
                                    }
                                    projectName={projectName}
                                    refetch={refetch}
                                    setEditTaskId={setEditTaskId}
                                    setIsSaveAndEditTask={setIsSaveAndEditTask}
                                  />
                                </div>
                          </div>
                          <div className="mt-4 mb-4 d-flex justify-content-between">
                            <div className="left d-flex flex-wrap gap-3">
                              <div
                                className="  btn btn-outline-danger me-2"
                                onClick={() => {
                                  reset();
                                  if (projectId) {
                                    navigate(
                                      `/project-template?projectId=${projectId}`
                                    );
                                  } else {
                                    navigate(`/project-template`);
                                  }
                                }}
                              >
                                Cancel
                              </div>
                              <div className="  rounded-circl notification-count">
                                <div
                                  
                                  className="btn btn-dark me-2"
                                  onClick={() => handleExternalSubmit()}
                                >
                                  Attachments
                                </div>
                                <div className="notification-count d-flex justify-content-center">
                                  {attachmentCount}
                                </div>
                              </div>
                              {/* <div className="  rounded-circl notification-count">
                                <a
                                  href="#!"
                                  className="btn btn-dark me-2"
                                  onClick={() => setTab("notifications")}
                                >
                                  Notifications
                                </a>
                                <div className="notification-count">24</div>
                              </div> */}
                            </div>
                            <div className="right">
                              <button className="btn btn-primary  ">
                                Save
                              </button>
                            </div>
                          </div>
                        </form>
                      );
                    case "attachments":
                      return (
                        <Attachment
                          setTab={setTab}
                          setAttachmentCount={setAttachmentCount}
                          setTitle={setTitle}
                          attachmentType={"projectTemp"}
                          TranType={3}
                          AttchType={1}
                        />
                      );
                    case "notifications":
                      return <></>;
                    // case "attachments":
                    //   return <Attachments />;
                    // case "notifications":
                    //   return <Notifications />;
                    default:
                  }
                })()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddUpdateProjectTemp;
